module.exports = __webpack_public_path__ + "static/media/effect_button_purchase.eb830bfa.mp3";